import { ErrorResponse, FgStatusEnum, GlobalStatus, InventoryTypeEnum, OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { ProductConversionDetailsResponseModel, ProductConversionResponseModel } from '@gtpl/shared-models/production-management';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { getConnection, getManager, Raw, Repository } from 'typeorm';
import { ProductionInventory } from '../operations-track/entities/production-inventory.entity';
import { ProductionInventoryRepository } from '../operations-track/repositories/production-inventory.repository';
import { ProductConversionAdapter } from './dto/product-conversion.adapter';
import { ProductConversionRepository } from './dto/product-conversion.repository';
import { ProductConversionRequestDto } from './dto/product-conversion.request.dto';
import { ProductConversion } from './product-conversion.entity';

@Injectable()
export class ProductConversionService {
    constructor(
        @InjectRepository(ProductConversion)
        private productConversionRepository: Repository<ProductConversion>,
        private productConversionAdapter: ProductConversionAdapter,
        private saleService: SaleOrderService,
    ) { }
    async createProductConversion(productConversionRequestDto: ProductConversionRequestDto, isUpdate: boolean): Promise<ProductConversionResponseModel> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const convertedProductConversion: ProductConversion = this.productConversionAdapter.convertDtoToEntity(productConversionRequestDto, isUpdate);
            const savedProductConversionEntity: ProductConversion = await manager.getCustomRepository(ProductConversionRepository).save(convertedProductConversion);
            const savedProductConversionDto: ProductConversionRequestDto = this.productConversionAdapter.convertEntityToDto(savedProductConversionEntity);
            if (savedProductConversionDto) {
                // generating resposnse
                let newProductionInvRecord;
                let getInvDetails =  await manager.getCustomRepository(ProductionInventoryRepository).findOne({where:{productionInventoryId:productConversionRequestDto.prodInvId}});
                let updateInventory = await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:productConversionRequestDto.prodInvId}, {convertedBoxes:()=>`converted_boxes+${productConversionRequestDto.boxes}`,conversionQuantity:()=>`conversion_quantity+${productConversionRequestDto.quantity}`,updatedUser:productConversionRequestDto.createdUser});
                if(productConversionRequestDto.fromOperation === "REJECTION"){
                    let updateInventory = await manager.getCustomRepository(ProductionInventoryRepository).update({productionInventoryId:productConversionRequestDto.prodInvId}, {rejectedQuantity:()=>`rejected_quantity-${productConversionRequestDto.quantity}`});
                }
                const soInfo = await this.saleService.getPoNumberForSoId({saleOrderId:productConversionRequestDto.toSaleOrder});
                if(!soInfo && soInfo.data.saleOrderId === null){
                    await manager.releaseTransaction();
                    return new ProductConversionResponseModel(false,1010, 'SO details not found. ');
                }   
                const variantInfo = await this.saleService.getVarientInfoForSoItem({saleOrderItemId: productConversionRequestDto.toSaleOrderItemId});
                if(!variantInfo && variantInfo.data.variantCode === null){
                    await manager.releaseTransaction();
                    return new ProductConversionResponseModel(false,1010, 'Product SKU details not found. ');
                }   
                const subLotNumber = getInvDetails.lotNumber+'-'+soInfo.data.SoInvDetailsInfo.poNumber+'-'+getInvDetails.inputGrade+'-'+variantInfo.data.variantCode;
                if(updateInventory.affected > 0){
                    const prodInv = new ProductionInventory();
                    prodInv.assignedRejection = 0;
                    prodInv.boxes = productConversionRequestDto.boxes;
                    prodInv.conversionQuantity = 0;
                    prodInv.convertedBoxes = 0;
                    prodInv.createdUser = productConversionRequestDto.createdUser;
                    prodInv.inputGrade = getInvDetails.inputGrade;
                    prodInv.intransitQuantity = 0;
                    prodInv.inventoryType = InventoryTypeEnum.Product_Conversion;
                    prodInv.issuedQuantity = 0;
                    prodInv.lotNumber = getInvDetails.lotNumber;
                    prodInv.nextOperation = OperationTypeEnum[productConversionRequestDto.toOperation];
                    prodInv.opBoxes = getInvDetails.opBoxes;
                    prodInv.operation = getInvDetails.operation;
                    prodInv.operationCategory = getInvDetails.operation;
                    prodInv.outputGrade = getInvDetails.outputGrade;
                    prodInv.physicalQuantity = productConversionRequestDto.quantity;
                    prodInv.plantId = getInvDetails.plantId;
                    prodInv.rejectedQuantity = 0;
                    prodInv.saleOrderId = productConversionRequestDto.toSaleOrder;
                    prodInv.saleOrderItemId = productConversionRequestDto.toSaleOrderItemId;
                    prodInv.status = FgStatusEnum.OPEN;
                    prodInv.stockTransferQty = 0;
                    prodInv.subLotNumber = (getInvDetails.nextOperation === OperationTypeEnum.BE_HEADING || getInvDetails.nextOperation === OperationTypeEnum.GRADING) ? getInvDetails.lotNumber: subLotNumber;
                    prodInv.subPlantId = getInvDetails.subPlantId;
                    prodInv.transferedBoxes = 0;
                    prodInv.wastageQuantity = 0;
                    prodInv.weighmentReq = GlobalStatus.NO;
                    prodInv.wipQuantity = 0;
                    newProductionInvRecord = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                    console.log(newProductionInvRecord);
                }
                if(newProductionInvRecord.productionInventoryId > 0){
                    let updateconvertedProdInvId = await manager.getCustomRepository(ProductConversionRepository).update({productConversionId:savedProductConversionDto.productConversionId}, {convertedProdInvId:newProductionInvRecord.productionInventoryId});
                    if(updateconvertedProdInvId.affected > 0){
                        await manager.completeTransaction();
                        return new ProductConversionResponseModel(true,1001, 'Product Conversion Created Successfully', savedProductConversionDto);
                    }
                    else{
                        await manager.releaseTransaction();
                        return new ProductConversionResponseModel(false,1010, 'Something went wrong. ', savedProductConversionDto);
                    }
                }
                else{
                    await manager.releaseTransaction();
                    return new ProductConversionResponseModel(false,1010, 'Something went wrong. ', savedProductConversionDto);
                }
            } else {
                await manager.releaseTransaction();
                return new ProductConversionResponseModel(false,1010, 'Something went wrong. ', savedProductConversionDto);
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }

    async getProductConversionDetails(@Body() req: PlantIdRequest): Promise<ProductConversionDetailsResponseModel> {
        const manager = getManager();
        try {
            // CONCAT(sid.po_number,"/",sku.variant_code) AS fromSaleOrder
            let query = 'select CONCAT(pcl.lot_code,IF(g.remarks IS NOT NULL,  " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) AS concatLotNum,u.unit_name AS plant,pcl.created_at AS date,CONCAT(soi.po_number,"/",skuu.variant_code) AS toSaleOrder, CONCAT(pi.sub_lot_number,IF(g.remarks IS NOT NULL,"-",""),IF(g.remarks IS NOT NULL,g.remarks,"")) as fromSaleOrder,pcl.quantity AS quantity,pcl.lot_code AS lotNumber,pcl.from_operation AS fromOperation, pcl.to_operation AS toOperation, pcl.conversion_reason AS reason, pcl.remarks AS remarks, pcl.boxes AS boxes from '+appSettings.production_db+'.product_conversion_log pcl left join '+appSettings.sales_db+'.sale_order_items si on si.sale_order_item_id = pcl.from_sale_order_item_id left join '+appSettings.sales_db+'.sale_order_items sii on sii.sale_order_item_id = pcl.to_sale_order_item_id Left join '+appSettings.masters_db+'.sku_codes sku on sku.sku_code_id = si.varient_id Left join '+appSettings.masters_db+'.sku_codes skuu on skuu.sku_code_id = sii.varient_id Left join '+appSettings.masters_db+'.unitcodes u on u.unit_code_id = pcl.plant_id Left join '+appSettings.production_db+'.production_inventory pi on pi.prod_inv_id = pcl.converted_prod_inv_id left join '+appSettings.sales_db+'.so_invoice_details soi on soi.sale_order_id = pcl.to_sale_order left join '+appSettings.sales_db+'.so_invoice_details sid on sid.sale_order_id = pcl.from_sale_order left join '+appSettings.rm_procure_db+'.grn_items g on pcl.lot_code=g.lot_number'  
            // where pcl.plant_id = '+req.unitcodeId;
            if (req.unitcodeId && req.unitcodeId != 5) {
                query = query + ' where pcl.plant_id = ' + req.unitcodeId;
            }
            let response = await manager.query(query);
            if(response.length > 0){
                return new ProductConversionDetailsResponseModel(true,1001,"Conversions Data retrived successfully. ",response);
            }
            else{
                return new ProductConversionDetailsResponseModel(false,1010,"Something went wrong. ");
            }
        }catch (error) {
            return error;
        }
    }
}